window.docCollectorLines = (function () {
    let lines = [];
    const Z_INDEX = 1;
    let isInitialized = false;

    function clearLines() {
        while (lines.length > 0) {
            const line = lines.pop();
            try {
                line.remove();
            } catch (e) {
            }
        }
    }
    
    function connectRepeat(repeatId, targetId) {
        if (!window.LeaderLine) {
            return;
        }

        const repeatEl = document.getElementById(repeatId);
        const targetEl = document.getElementById(targetId);

        if (!repeatEl || !targetEl) {
            return;
        }

        try {
            const line = new LeaderLine(
                repeatEl,
                targetEl,
                {
                    path: 'grid',
                    startSocket: 'right',
                    endSocket: 'right',
                    startSocketGravity: 130,
                    startPlug: 'behind',
                    endPlug: 'arrow3',
                    size: 3,
                    color: '#6366F1'
                }
            );

            if (line._line) {
                line._line.style.zIndex = Z_INDEX;
            }

            lines.push(line);
        } catch (e) {
        }
    }

    function repositionLines() {
        const validLines = [];
        
        lines.forEach(line => {
            try {
                const start = line.start;
                const end = line.end;
                
                if (document.body.contains(start) && document.body.contains(end)) {
                    line.position();
                    validLines.push(line);
                } else {
                    line.remove();
                }
            } catch (e) {
                try {
                    line.remove();
                } catch (removeError) {
                }
            }
        });
        
        lines.length = 0;
        lines.push(...validLines);
    }

    function initialize() {
        if (isInitialized) {
            return;
        }

        document.addEventListener('scroll', repositionLines, true);
        isInitialized = true;
    }

    function cleanup() {
        clearLines();

        document.removeEventListener('scroll', repositionLines, true);

        isInitialized = false;
    }

    return {
        initialize,
        connectRepeat,
        clearLines,
        cleanup
    };
})();